import { api } from "../httpClient";
import { API_ENDPOINTS } from "../config";

export const createSupportRequest = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.SUPPORT_REQUEST, payload);

    return response;
  } catch (error) {
    console.error("Support Request failed:", error);
    throw error;
  }
};